import { Box, CircularProgress } from "@mui/material"
import type { FC } from "react"
import { FormProvider } from "react-hook-form"

import { AccountingSettingsForm } from "../components/AccountingSettingsForm"
import { AccountingSettingsHeaderActions } from "../components/AccountingSettingsHeaderActions"
import { useAccountingSettingsForm } from "../hooks/useAccountingSettingsForm"
import { useGetAccountingSettings } from "../hooks/useGetAccountingSettings"

import { CancelDialog, ConfirmationDialog } from "@/components/common/Modals"

export const AccountingSettingsContainer: FC = () => {
  const { settings, isFetching } = useGetAccountingSettings()

  const {
    methods,
    isConfirmationOpen,
    isNavigationBlocked,
    isDirty,
    isUpdating,
    canSubmit,
    handleSaveClick,
    handleConfirmSave,
    handleConfirmCancel,
    handleNavigationCancel,
    handleNavigationConfirm,
  } = useAccountingSettingsForm({ settings })

  if (isFetching) {
    return (
      <Box className='flex items-center justify-center p-16'>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <FormProvider {...methods}>
      <Box className='flex flex-col gap-6'>
        <AccountingSettingsHeaderActions
          isDirty={isDirty}
          canSubmit={canSubmit}
          isSubmitting={isUpdating}
          onSaveClick={handleSaveClick}
        />
        <AccountingSettingsForm />
      </Box>
      {isConfirmationOpen && (
        <ConfirmationDialog
          title='Are you sure?'
          content='Save the changes to your Accounting Settings?'
          closeLabel='Go Back'
          confirmLabel='Save'
          onClose={handleConfirmCancel}
          onConfirm={handleConfirmSave}
        />
      )}
      {isNavigationBlocked && <CancelDialog onClose={handleNavigationCancel} onConfirm={handleNavigationConfirm} />}
    </FormProvider>
  )
}
